module.exports = __webpack_public_path__ + "img/babe_babe.hodl.f60b9c6.png";